









import Vue from 'vue';

export default Vue.extend({
    name: 'SummaryInstruction',
    props: ['template', 'video'],
});
